var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-wrap"},[_c('WrappedChipList',{attrs:{"items":_vm.suggestedAttributes,"inline":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var attribute = ref.item;
return [_vm._v(" "+_vm._s(attribute.key)+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }